import script from "./pwa.vue?vue&type=script&setup=true&lang=js"
export * from "./pwa.vue?vue&type=script&setup=true&lang=js"

import "./pwa.vue?vue&type=style&index=0&id=19d4a2f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19d4a2f4"]])

export default __exports__